import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip'
import { useTranslation } from '@Globals/Translations'

import { chipLabelFallback, generateChipLabel, getChipVariant } from './ChipHelper'

interface DiscountProps extends ChipProps {
  discount: {
    context?: string
    percentage?: number
  }
}

export const DiscountChip: FC<DiscountProps> = ({ discount, size = 'medium' }) => {
  const { t } = useTranslation()
  const { context = '', percentage = 0 } = discount
  const label = t('common:product_tag_discount', {
    context,
    discountPercent: percentage,
  })

  const discountType = context ?? 'discount'
  let discountText = label
  if (label === 'product_tag_discount') {
    const fallbackLabel = t(chipLabelFallback[discountType.toLowerCase()] || '')
    const variant = getChipVariant(discountType)
    discountText = generateChipLabel(fallbackLabel, discountType, variant, percentage)
  }
  if (discountText === '') {
    return null
  }
  return (
    <Chip
      color="red"
      fadedBackground
      fontWeight="bold"
      size={size}
      uppercase
    >
      {discountText}
    </Chip>
  )
}

